import React from 'react';
import {useAppSelector} from "common/hook";
import {getCabinetData} from "entities/Cabiner/model/selectors/getCabinetData/getCabinetData";
import {LESSON_TITLE} from "entities/constants/constants";
import {NothingYetMessage} from "../../../../nothing-yet-message/NothingYetMessage";
import {Link, NavLink} from "react-router-dom";

export const ClassesCart = () => {
    const cabinetData = useAppSelector(getCabinetData)

    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h4">{LESSON_TITLE}</p>
                </div>
                {cabinetData?.lessons &&
                    <span className="sub-data">
                        {cabinetData?.lessons.month}
                    </span>
                }
            </div>
            {cabinetData?.lessons?.items && cabinetData?.lessons.items.length > 0 ? (
                <div className="info-card-content">
                    {cabinetData?.lessons.items.map((classItem, index) => (
                        <div className="row" key={index}>
                            <p>
                                <Link to={`/groups/${classItem.group.id}/lessons/${classItem.id}`}>{classItem.title}</Link>
                            </p>
                            <div className="group-item-data">
                                {classItem.isNew && (
                                    <span className="complited-count">Новое</span>
                                )}
                                <time className="time">
                                    {classItem.date}, {classItem.time}
                                </time>
                                <p>
                                    <NavLink to={`/groups/${classItem.group.id}`}>
                                        {classItem.group.title}
                                    </NavLink>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="info-card-content">
                    <NothingYetMessage/>
                </div>
            )}
        </div>
    );
};
